const Worker = () => import('@/views/worker/worker')
const WorkerInfo = () => import('@/views/worker/worker-info')
const JsRecruit = () => import('@/views/worker/JsRecruit')
const checkResult = () => import('@/views/worker/checkResult')

export default {
  path: '/worker',
  name: 'worker',
  component: Worker,
  meta: {
    title: '技师招募',
    auth: true
  },
  children: [
    {
      path: '/worker/JsRecruit',
      name: 'workerInfo',
      component: JsRecruit,
      meta: {
        title: '技师招募',
        auth: false
      }
    },
    {
      path: '/worker/workerInfo',
      name: 'workerInfo',
      component: WorkerInfo,
      meta: {
        title: '技师信息',
        auth: true,
        noHeader: true,
        intercept: true
      }
    },
    {
      path: '/worker/checkResult',
      name: 'checkResult',
      component: checkResult,
      meta: {
        title: '审核结果',
        auth: true,
        noHeader: true
      }
    }
  ]
}
